import type { Type } from '@angular/core';
import { InjectionToken } from '@angular/core';

import type { DataSourceLayout, ViewLayoutState, ViewRecord } from '@core/views-types';

export interface LayoutContainer {
  container: () => Promise<Type<any>>;
  type: DataSourceLayout['type'];
}
export const LAYOUT_CONTAINER = new InjectionToken<LayoutContainer[]>('LAYOUT_CONTAINER');

export interface DataTransform<From extends ViewRecord, To extends ViewRecord> {
  transform: (viewRecordState: ViewLayoutState<From>) => ViewLayoutState<To>;
}

export const NOOP_TRANSFORM: DataTransform<ViewRecord, ViewRecord> = { transform: v => v };
